import { Outlet, useLoaderData, redirect } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export async function loader({ request }) {
  const token = localStorage.getItem("token");

  const url = new URL(request.url); // Get current location
  const from = url.pathname; // Extract the "from" path

  if (!token) {
    return redirect(
      `/login?message=You%20must%20log%20in%20first.&from=${encodeURIComponent(
        from
      )}`
    );
  }

  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000;

    if (decoded.exp && decoded.exp < now) {
      localStorage.removeItem("token");
      return redirect(
        `/login?message=Session%20expired.%20Please%20log%20in%20again.&from=${encodeURIComponent(
          from
        )}`
      );
    }

    return null; // Continue to the route
  } catch (err) {
    localStorage.removeItem("token");
    return redirect(
      `/login?message=Invalid%20token.%20Please%20log%20in%20again.&from=${encodeURIComponent(
        from
      )}`
    );
  }
}

function AuthRequired() {
  const authentication = useLoaderData();
  return <Outlet />;
}

export default AuthRequired;
